import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";

import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import CircularProgress from "@mui/material/CircularProgress";

import { db, setDoc, doc } from "../../firebase";
import Alert from "@mui/material/Alert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { InputAdornment } from "@mui/material";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import {
  functions,
  httpsCallable,
  serverTimestamp,
  addDoc,
  collection,
  query,
  where,
  getDocs,
  getDoc,
} from "../../firebase";

import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import emailjs from "@emailjs/browser";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://heslet.net/">
        Heslet LLC.
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function SignUp() {
  const urllocation = useLocation();

  const { naver } = window;
  let navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const { signup, setStripeUserId, signinWithGoogleAccount } = useAuth();
  const [error, setError] = useState("");
  const [processing, setProcessing] = useState(false);
  const createStripeUser = httpsCallable(functions, "createStripeUser");
  const [DBerror, setDBerror] = useState("");

  const [clickSubmit, setClickSubmit] = useState(false);
  const { t, i18n } = useTranslation();
  const [mailing, setMailing] = useState(true);

  const handleChangeChk = (chkValue) => {
    setMailing(chkValue.target.checked);
  };

  console.log(mailing);

  const getLocation = async () => {
    fetch("https://extreme-ip-lookup.com/json/?key=gaU0ffh8j0GP3mESFth7")
      .then((res) => res.json())
      .then(async (response) => {
        console.log("=====> Country is : ", response);
        window.sessionStorage.setItem("iplookup", JSON.stringify(response));
        if (response.status === "success") {
          return response;
        }
      })
      .catch((data, status) => {
        console.log("Request failed:", data);
      });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  console.log(
    "window.sessionStorage.getItem(geolocation)",
    window.sessionStorage.getItem("geolocation")
  );

  const submit = async (data) => {
    setProcessing(true);
    console.log(data);

    try {
      let uid;
      await signup(
        data.email,
        data.password,
        data.firstname,
        data.lastname
      ).then((response) => {
        console.log("uid >>>", response.user.uid);
        uid = response.user.uid;
      });

      window.sessionStorage.removeItem("position");

      const name = data.firstname + " " + data.lastname;

      let response = getLocation();

      await setDoc(doc(db, "users", uid), {
        firstname: data.firstname.toUpperCase(),
        lastname: data.lastname.toUpperCase(),
        created: serverTimestamp(),
        mailing: mailing,
        email: data.email,
        location: JSON.parse(window.sessionStorage.getItem("iplookup"))
          .countryCode,
        language: i18n.language,
      });

      // 메일링 리스트에 넣기
      if (mailing === true) {
        const docRef = doc(db, "mailing", data.email);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
          await setDoc(doc(db, "mailing", data.email), {
            email: data.email,
          });
        }
      }

      // Send it to the customer
      var templateParams1 = {
        user_email: data.email,
        firstname: data.firstname,
        lastname: data.lastname,
      };
      emailjs
        .send(
          "service_66owpwy",
          "template_w8e48jg",
          templateParams1,
          "user_7Zql27tiMF2NZkNx1LGdg"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );

      // const docRef = await addDoc(collection(db, "mail"), {
      //   to: data.email,
      //   message: {
      //     location: window.sessionStorage.getItem("geolocation"),
      //     subject: "Hello from Heslet LLC",
      //     html: `<!DOCTYPE html>
      //     <html lang="en">
      //     <head>
      //         <meta charset="UTF-8">
      //         <meta http-equiv="X-UA-Compatible" content="IE=edge">
      //         <meta name="viewport" content="width=device-width, initial-scale=1.0">
      //         <title>Thank you!</title><style>
      //             @import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
      //             .myDiv {
      //                 font-family: 'Roboto', sans-serif;
      //               border: 1px solid lightgray;
      //               width:400px;
      //              margin-left:auto;margin-right:auto;padding-top:20px;padding-bottom:40px;
      //              padding-left:20px; padding-right:20px; line-height: 1.8em;
      //             }
      //             .logo{display:flex;  justify-content: space-between;}
      //             .confirm{top:+40px;position:relative}
      //             .blue{color:#153a5a; font-weight: bold;}
      //             .hello{padding-top:30px}
      //             .detail{padding-top:30px;border-bottom:1px solid lightgray;}
      //             .order{padding-top:20px}
      //             .green{color:#689f38}
      //             .custom_btn{background-color: #153a5b;cursor:pointer;
      //       color: white;
      //       letter-spacing: 3px;
      //       border-radius: 0;
      //       width: 100%;
      //       border: none;
      //       text-transform: uppercase;
      //       padding-top: 15px;
      //       padding-bottom: 15px;
      //       cursor: pointer;}
      //         .button{padding-top:20px}
      //         .ship{padding-top:20px}
      //         .Recommendations{padding-top:40px}
      //         .bottom{font-size: 11px;padding-top:50px;line-height: 1.5em;}
      //         .recomm{padding-top:20px; display:flex; font-size:13px;line-height: 1.5em;text-align: center;
      //         justify-content: space-evenly;}
      //         .custom_btn_whitebg {
      //       border: 1px #212a2f solid;
      //       color: black;
      //       letter-spacing: 3px;
      //       border-radius: 0;
      //       width: 100%;
      //       border: none;
      //       text-transform: uppercase;
      //       padding-top: 15px;
      //       padding-bottom: 15px;
      //       cursor: pointer;
      //     }

      //           </style>
      //     </head>
      //     <body>
      //         <div class="myDiv">
      //             <div class="logo"><img src="https://prism-a6a80.firebaseapp.com/img/heslet_logo.png" width="60" height="" />
      //             <div class="confirm" style="padding-top:50px; padding-left:30px;">Welcome From Heslet</div></div>
      //             <br />
      //             <div class="blue hello">Hello ${data.firstname},</div>
      //             <br />Thank you for signing up to Heslet.com. We make healthy and enviromental-friendly products.

      //             <div class="button"><a href="http://localhost:3007/products-cleansing"><button class="custom_btn">our products</button></a></div>
      //             <div class="button"><a href="http://localhost:3007/products-cleansing"><button class="custom_btn_whitebg">Our Technology</button></a></div>

      //             <div class="Recommendations">
      //                  Recommendations for items from across our store
      //             </div>
      //             <div class="recomm">

      //                 <div class="each" style="padding-right:30px;">
      //                     <img src="https://prism-a6a80.firebaseapp.com/img/heavy-duty.jpeg" width="100" />
      //                     <div>Premium Heavy Duty<br /> Hand Wipes</div>
      //                 </div>
      //                 <div class="each" style="padding-right:30px;">
      //                     <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Wipe.png" width="100" />
      //                     <div>Premium<br /> All-Purpose Wipes</div>
      //                 </div>
      //                 <div class="each">
      //                     <img src="https://prism-a6a80.firebaseapp.com/img/All-Purpose-Spray.png" width="100" />
      //                     <div>Premium <br />All Purpose Spray</div>
      //                 </div>
      //             </div>

      //             <div class="bottom">This email was sent from a notification-only address that cannot accept incoming email. Please do not reply to this message.</div>
      //         </div>

      //     </body>
      //     </html>`,
      //   },
      // });
      // console.log("docRef", docRef);

      navigate("/dashboard");

      // createStripeUser({
      //   email: data.email,
      //   name: name,
      // }).then(async (stripeData) => {
      //   stripeUser = stripeData.data;
      //   console.log("stripeUser.id >>>", stripeUser.id);

      //   // set stripe id to auth context
      //   setStripeUserId(stripeUser);
      //   console.log({
      //     firstname: data.firstname,
      //     lastname: data.lastname,
      //     stripeId: stripeUser.id,
      //   });

      //   await setDoc(doc(db, "users", uid), {
      //     firstname: data.firstname,
      //     lastname: data.lastname,
      //     stripeId: stripeUser.id,
      //     created: new Date(),
      //   });

      //   navigate("/dashboard");
      // });
    } catch (error) {
      console.log(error.code);
      switch (error.code) {
        case "auth/wrong-password":
          setDBerror(t("pass_wrong"));
          break;
        case "auth/user-not-found":
          setDBerror(t("doesntexist"));
          break;
        case "auth/email-already-in-use":
          setDBerror(t("already"));
          break;
        case "auth/too-many-requests":
          setDBerror("Too many requests. Try again later.");
          break;
        case "auth/operation-not-allowed":
          setDBerror("Signing in with Email and Password is not enabled.");
          break;
        default:
          setDBerror("An undefined error happened. Please try again.");
      }
    }

    setProcessing(false);
  };

  const signinWithGoogle = async () => {
    try {
      const result = await signinWithGoogleAccount();
      console.log(result);
    } catch (error) {
      setError(
        (old) => "There is an error logging with your google. Please try again."
      );
    }
  };
  const getNaverToken = () => {
    if (!urllocation.hash) return;
    return urllocation.hash.split("=")[1].split("&")[0];
  };
  useEffect(() => {
    const token = getNaverToken();
    console.log("token", token);
    initializeNaverLogin(token);
  }, []);

  const initializeNaverLogin = (token) => {
    const naverLogin = new naver.LoginWithNaverId({
      clientId: "KWVpgJ5ZYEOugfR6qcqt",
      callbackUrl: "https://prism-a6a80.firebaseapp.com/signup",
      isPopup: false, // popup 형식으로 띄울것인지 설정
      loginButton: { color: "white", type: 3, height: "47", width: "100%" }, //버튼의 스타일, 타입, 크기를 지정
    });
    console.log(naverLogin);
    naverLogin.init();
    console.log("token", token);
    // naverLogin.logout();

    naverLogin.getLoginStatus(async (status) => {
      console.log("status", status);
      if (status && token) {
        console.log("naver login 상태", naverLogin.user);
        const { id, email, gender, birthday, name } = naverLogin.user;

        const q = query(collection(db, "users"), where("email", "==", email));
        const querySnapshot = await getDocs(q);

        let count = 0;
        querySnapshot.forEach((doc) => {
          count++;
          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, " => ", doc.data());
        });

        if (count === 0) {
          submit({
            password: id.substring(0, 8),
            firstname: name.charAt(0),
            lastname: name.substring(1, name.length),
            email: email,
          });
        } else {
          if (clickSubmit)
            setError(
              "지금 귀하의 네이버 이메일은 등록되어 있습니다. 로그인 해주세요."
            );
        }

        // if (gender === undefined) {
        //   alert("성별은 필수 동의입니다. 정보제공을 동의해주세요.");
        //   naverLogin.reprompt();
        //   return;
        // }
      }
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "380px",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "#6573c3" }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {t("signup")}
        </Typography>

        <Box noValidate sx={{ mt: 3 }}>
          <form
            onSubmit={handleSubmit((data) => {
              submit(data);
            })}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  variant="filled"
                  label={t("ln")}
                  autoComplete="family-name"
                  {...register("lastname", {
                    required: "Last name is required.",
                    minLength: {
                      value: 1,
                      message: "Last Name's minimum length is 1.",
                    },
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="given-name"
                  variant="filled"
                  fullWidth
                  label={t("fn")}
                  autoFocus
                  {...register("firstname", {
                    required: "First name is required.",
                    minLength: {
                      value: 1,
                      message: "First Name's minimum length is 1.",
                    },
                  })}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="email"
                  variant="filled"
                  label={t("email")}
                  autoComplete="email"
                  {...register("email", {
                    required: "Email is required.",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Please put valid email address.",
                    },
                  })}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  {...register("password", {
                    required: "Password is required.",
                    minLength: {
                      value: 1,
                      message: "Last Name's minimum length is 1.",
                    },
                  })}
                  fullWidth
                  variant="filled"
                  label={t("pass")}
                  type={showPassword ? "text" : "password"}
                  autoComplete="new-password"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment
                        sx={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} sx={{ mb: 3, mt: 2 }}>
								<FormControlLabel
									control={
										<Checkbox value="allowExtraEmails" color="primary" />
									}
									label="I want to receive inspiration, marketing promotions and updates via email."
								/>
							</Grid> */}
            </Grid>

            <Box
              sx={{
                paddingTop: "10px",
                fontWeight: "bold",

                width: 1,
                fontSize: "13px",
                color: "#ff385c",
                position: "relative",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  position: "relative",
                  top: "+3px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {errors.firstname && (
                  <Alert severity="warning">{errors.firstname?.message}</Alert>
                )}
                {!errors.firstname && errors.lastname && (
                  <Alert severity="warning">{errors.lastname?.message}</Alert>
                )}
                {!errors.firstname && !errors.lastname && errors.email && (
                  <Alert severity="warning">{errors.email?.message}</Alert>
                )}
                {!errors.firstname &&
                  !errors.lastname &&
                  !errors.email &&
                  errors.password && (
                    <Alert severity="warning">{errors.password?.message}</Alert>
                  )}
                {!errors.firstname &&
                  !errors.lastname &&
                  !errors.email &&
                  !errors.password &&
                  DBerror && <Alert severity="warning">{DBerror}</Alert>}
                {!errors.firstname &&
                  !errors.lastname &&
                  !errors.email &&
                  !errors.password &&
                  error && <Alert severity="warning">{error}</Alert>}
              </div>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mt: 2, ml: 2 }}>
              {mailing ? (
                <input
                  type="checkbox"
                  value={mailing}
                  checked="checked"
                  onChange={(event) => handleChangeChk(event)}
                  id="mailing"
                  name="mailing"
                />
              ) : (
                <input
                  type="checkbox"
                  value={mailing}
                  onChange={(event) => handleChangeChk(event)}
                  id="mailing"
                  name="mailing"
                />
              )}

              <label htmlFor="mailing" style={{ marginLeft: "8px" }}>
                {t("Join our mailing list")}
              </label>
            </Box>
            <Box sx={{ color: "gray", mt: 1, ml: 3 }}>
              {t(
                "Sign up to receive email updates on our new products, sales, and more."
              )}
            </Box>
            <Box sx={{ my: 3 }}>
              <button
                type="submit"
                fullWidth
                variant="contained"
                className="custom_btn"
                disabled={processing}
                onClick={() => setClickSubmit(true)}
              >
                <>
                  {processing ? (
                    <>
                      <CircularProgress size={12} />
                    </>
                  ) : (
                    <>{t("signup")}</>
                  )}
                </>
              </button>
            </Box>
          </form>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: 1,
              display: "flex",
              justifyContent: "center",
              pb: 2,
            }}
          >
            <div id="naverIdLogin" />
          </Box>
          <Grid container justifyContent="flex-end" sx={{ fontSize: "14px" }}>
            <Grid item>
              <Link href="/login" variant="body2">
                {t("already_signin")}
              </Link>
            </Grid>
          </Grid>
        </Box>
        <Copyright sx={{ mt: 8, mb: 10 }} />
      </Box>
      <Box sx={{ pt: 5 }}>
        {/* <Button
          onClick={signinWithGoogle}
          startIcon={
            <img
              width="20"
              height="20"
              src="https://www.freepnglogos.com/uploads/google-logo-png/google-logo-vector-graphic-pixabay-15.png"
              alt=""
            />
          }
          fullWidth
          sx={{
            backgroundColor: "#4285f4",
            color: "white",
            borderRadius: 0,
            boxShadow: "1px 1px 1px grey",
            letterSpacing: "1.3px",
            cursor: "pointer",
            "&:hover": { backgroundColor: "#546e7a" },
            pt: 1,
            px: 2,
          }}
        >
          Sign up With Google Account
        </Button> */}
      </Box>
    </Box>
  );
}
